import { render } from "./Header.vue?vue&type=template&id=54c343a8"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=54c343a8&lang=css"
script.render = render

export default script